import { useNavigate } from "react-router-dom";
import PageAboutSectionCard from "../../../views/datacard/RectangleSectionCard";
import SlidingPane from "react-sliding-pane";
import { Draggable } from "react-drag-reorder";
import { useDispatch, useSelector } from "react-redux";
import {
  contactPageAction,
  roomPageAction,
} from "../../../redux/actions/PageAction";
import { RootState } from "../../../redux/store";
import wbApi from "../../../API/wbApi";
import { useCallback, useEffect, useState } from "react";
import CustomBreadcrumbs from "../../../Components/breadCrumb/CustomBreadcrumbs";
import Loader from "../../../views/loader/Loader";
import CardWrapper from "../../../views/datacard/CardWrapper";
import NoDataComponent from "../../../Components/noDataComponent/NoDataComponent";
import { CATCH_MESSAGE, getImage } from "../../../UtilityFunctions";
import { toast } from "react-toastify";
import {
  CancelConfirmationPrompt,
  ShowConfirmationPrompt,
} from "../../../redux/actions/PromptAction";
import Button from "../../../views/buttons/Button";
import ConatctSeoSlider from "./ConatctSeoSlider";
import ConatctPageTitleSlider from "./ConatctPageTitleSlider";
import ConatctSectionSlider from "./ConatctSectionSlider";
// import RoomPageTitleSlider from "./RoomPageTitleSlider";
// import RoomSectionSlider from "./RoomSectionSlider";
// import RoomSeoSlider from "./RoomSeoSlider";

const RoomsPage = () => {
  const { company_id, auth_token } = useSelector(
    (state: RootState) => state.auth
  );
  const { template_id } = useSelector((state: RootState) => state.template_id);
  const { page_Id } = useSelector((state: RootState) => state.pages);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // States
  const [openTitleSlide, setOpenTitleSlide] = useState<boolean>(false);
  const [saveLoader, setSaveLoader] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [openSeoSlide, setOpenSeoSlide] = useState<boolean>(false);
  const [loader, setLoader] = useState<boolean>(false);
  const [allsec, setAllSec] = useState<any[]>([]);
  const [conatctPageSec, setConatctPageSec] = useState<any[]>([]);
  const [updateOrder, setUpdateOrder] = useState<any[]>([]);
  const [contactPageDetails, setContactPageDetails] = useState<any>({});

  useEffect(() => {
    contactPageDataFetching();
  }, []);

  const contactPageDataFetching = async () => {
    setLoader(true);
    try {
      let PageRes = await wbApi.get(
        `/wb-dashboard/fetch-wb-contact-page-details/${company_id}/${template_id}/${page_Id}`

      );
      // console.log("roomPageData", contactPageData);

      if (PageRes.data.status === 1) {
        dispatch(contactPageAction(PageRes?.data));
        const roomPageAllSec = PageRes?.data?.all_sections?.map((item: any) => {
          return { ...item, isChecked: false };
        });
        setAllSec(roomPageAllSec);
        setConatctPageSec(PageRes?.data?.contact_page_details?.page_section);
        setContactPageDetails(PageRes?.data?.contact_page_details);

        setLoader(false);
      } else {
        setAllSec([]);
        setConatctPageSec([]);
        setContactPageDetails({});
        setLoader(false);
      }
    } catch {
      setLoader(false);
    }
  };

  // Api To ReOrder
  const orderSaveHandler = async () => {
    setSaveLoader(true);
    try {
      let orderReq = await wbApi.post(
        "/wb/insert-update-page-section",
        {
          id: contactPageDetails?.id ?? "undefined",
          template_id: template_id,
          company_id: company_id,
          page_section: updateOrder,
          page_type: "Default",
          page_id: page_Id ?? "",
        },
        {
          headers: {
            Authorization: "Bearer " + auth_token,
          },
        }
      );
      if (orderReq.data.status === 1) {
        toast.success(orderReq.data.message);
        setDragStatus(false);
        contactPageDataFetching();
        setSaveLoader(false);
      } else {
        toast.error(orderReq.data.message);
        contactPageDataFetching();
        setSaveLoader(false);
      }
    } catch (error) {
      toast.error(CATCH_MESSAGE);

      setSaveLoader(false);
    }
  };

  // Section Delet Handler
  const deleteHandler = (index: any) => {
    dispatch(
      ShowConfirmationPrompt(
        `Are you sure want to delete this ?`,
        "DELETE",
        async () => {
          await deletSecHandler(index);

          dispatch(CancelConfirmationPrompt());
        }
      )
    );
  };

  const deletSecHandler = (index: any) => {
    let contactPageSections = [...conatctPageSec];
    contactPageSections.splice(index, 1);
    deletConatctSecDetails(contactPageSections);
  };
  // Delet Section Post
  const deletConatctSecDetails = async (updateSec: any) => {
    try {
      let deletAboutSecReq = await wbApi.post(
        "/wb/insert-update-page-section",
        {
          id: contactPageDetails?.id ?? "undefined",
          template_id: template_id,
          company_id: company_id,
          page_section: updateSec ?? [],
          page_type: "Default",
          page_id: page_Id ?? "",
        }
      );
      // console.log("deletHomeSecReq", deletAboutSecReq);
      if (deletAboutSecReq.data.status === 1) {
        toast.success(deletAboutSecReq.data.message);
        contactPageDataFetching();
      } else {
        toast.error(deletAboutSecReq.data.message);
        contactPageDataFetching();
      }
    } catch {
      toast.error(CATCH_MESSAGE);
    }
  };

  // Ordering Menus
  const positionHandler = (currentPos: any, newPos: any) => {
    const orderSec = [...conatctPageSec];
    const result = orderSec.splice(currentPos, 1);
    const upDateSec = orderSec.splice(newPos, 0, ...result);
    setDragStatus(true);
    setUpdateOrder(orderSec);
    // console.log(orderSec, "orderSec");
  };

  const [dragStatus, setDragStatus] = useState(false);

  // useEffect used to capture the section order if drag action is not triggered.
  useEffect(() => {
    if (!dragStatus) {
      setUpdateOrder(conatctPageSec)
    }
  }, [conatctPageSec, dragStatus])

  // Draggable Handler
  const DraggableRender = useCallback(() => {
    if (conatctPageSec && conatctPageSec?.length > 0) {
      return (
        <Draggable onPosChange={positionHandler}>
          {conatctPageSec?.map((sec: any, idx: any) => {
            return (
              <div className="section-card-wrapper" key={sec.id}>
                <PageAboutSectionCard
                  onDelet={() => {
                    deleteHandler(idx);
                  }}
                  onEdit={() => {
                    navigate(`/section-default/${sec.section_routes}`);
                  }}
                >
                  {sec.section_names}
                </PageAboutSectionCard>
              </div>
            );
          })}
        </Draggable>
      );
    }
    return null;
  }, [conatctPageSec]);

  return (
    <>
      <div>
        {/* Sub-Header */}
        <div className="wb-subheader">
          {/* BreadCrumbs */}
          <CustomBreadcrumbs
            content={[
              {
                label: "Pages",
                href: "/pages-default",
              },
              {
                label: `Default Pages`,
                href: "/pages-default",
              },
              {
                label: "Contact Us",
              },
            ]}
          />

          <div className="wb-subheader-rightsec">
            <Button
              icon="bi bi-binoculars"
              handleClick={() => {
                setOpenSeoSlide(true);
              }}
            >
              SEO
            </Button>
            <Button
              icon="bi bi-info-circle"
              handleClick={() => {
                setOpenTitleSlide(true);
              }}
            >
              Page Title
            </Button>
            <Button
              icon="bi bi-arrow-left"
              className="bck-btn"
              handleClick={() => {
                navigate(-1);
              }}
            >
              Back
            </Button>
          </div>
        </div>
        <div className="wb-divider"></div>

        {/* Main Section */}

        {loader ? (
          <div className="middle-loader">
            <Loader />
          </div>
        ) : (
          <>
            <div className=" mt-4 banner-img-wrapper">
              {contactPageDetails !== null ? (
                contactPageDetails?.banner ? (
                  <img
                    src={`${getImage(contactPageDetails?.banner)}`}
                    alt={contactPageDetails?.banner_alt}
                    className="banner-img"
                  />
                ) : contactPageDetails?.video_banner ? (
                  <video width="100%" height="300" controls autoPlay>
                    <source
                      src={`${getImage(contactPageDetails?.video_banner)}`}
                    />
                  </video>
                ) : contactPageDetails?.video_banner_link ? (
                  <iframe
                    src={contactPageDetails?.video_banner_link}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    height="100%"
                    width="100%"
                  ></iframe>
                ) : (
                  <NoDataComponent message="No Banner Found" />
                )
              ) : (
                <NoDataComponent message="No Data Found" />
              )}

              <div
                className="edit-btn-banner"
                onClick={() => {
                  navigate("edit-contact-banner");
                }}
              >
                <i className="bi bi-pencil-square"></i>
              </div>
              {/* <div className="banner-titel">
                <div className="b-titel-text">
                  {contactPageDetails?.banner_title ? (
                    <div className="">{contactPageDetails?.banner_title}</div>
                  ) : (
                    <div className="no-banner-titel">
                      TITLE & DESCRIPTION OF THE CONTACT PAGE
                    </div>
                  )}
                </div>
              </div> */}
            </div>

            <CardWrapper className="mt-4 about-add-sec-card">
              <Button
                icon="bi bi-plus-lg"
                className="section-btn"
                handleClick={() => {
                  setOpen(true);
                }}
              >
                Select Section
              </Button>
            </CardWrapper>

            {/* For Section */}

            <CardWrapper className=" mt-4 mb-4 home-section-save-wrapper">
              {conatctPageSec?.length > 0 ? (
                <>
                  <DraggableRender />
                  <Button
                    className="save-btn"
                    handleClick={() => {
                      orderSaveHandler();
                    }}
                    loader={saveLoader}
                  >
                    Save
                  </Button>
                </>
              ) : (
                <NoDataComponent message="No Section Found" />
              )}


            </CardWrapper>
          </>
        )}
      </div>
      {/* For Seo */}

      <SlidingPane
        hideHeader
        from="right"
        width="35%"
        isOpen={openSeoSlide}
        className="sliding-pane-custom"
        closeIcon={<i className="bi bi-x-lg"></i>}
        onRequestClose={() => setOpenSeoSlide(false)}
      >
        <ConatctSeoSlider
          onClose={() => {
            setOpenSeoSlide(false);
          }}
          contactPageDataFetching={contactPageDataFetching}
          contactPageDetails={contactPageDetails}
        />
      </SlidingPane>

      {/* For Title */}
      <SlidingPane
        hideHeader
        from="right"
        width="35%"
        isOpen={openTitleSlide}
        className="sliding-pane-custom"
        closeIcon={<i className="bi bi-x-lg"></i>}
        onRequestClose={() => setOpenTitleSlide(false)}
      >
        <ConatctPageTitleSlider
          onClose={() => {
            setOpenTitleSlide(false);
          }}
          contactPageDataFetching={contactPageDataFetching}
          contactPageDetails={contactPageDetails}
        />
      </SlidingPane>

      {/* For Section */}
      <SlidingPane
        hideHeader
        from="right"
        width="35%"
        isOpen={open}
        className="sliding-pane-custom"
        closeIcon={<i className="bi bi-x-lg"></i>}
        onRequestClose={() => setOpen(false)}
      >
        <ConatctSectionSlider
          onClose={() => {
            setOpen(false);
          }}
          contactPageDataFetching={contactPageDataFetching}
          allsec={allsec}
          contactPageDetails={contactPageDetails}
        />
      </SlidingPane>
    </>
  );
};

export default RoomsPage;
